import React from 'react';
import ApolloClient from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import Layout from '../../components/layout';
import SEO from '../../components/seo';
import { SettingProvider } from '../../lib/context/settings';
import { AdsProvider } from '../../lib/context/ads';
import { Col, Row, Collapse } from 'antd';
import { Title } from '../../components/styles';
import { device } from '../../lib/theme';
import styled from 'styled-components';

const { Panel } = Collapse;

const HeroContainer = styled(Row)`
  background-size: cover;
  background-position: right;
  background-repeat: no-repeat;
  height: 100px;
  margin: auto;
  h1 {
    max-width: 80%;
    font-size: 32px;
    line-height: 1.1;
  }

  @media ${device.laptop} {
    h1 {
      max-width: 60%;
      font-size: 56px;
      line-height: 1.2;
    }

    background-position: center center;
  }
`;

const client = new ApolloClient<any>({
  uri: `https://${process.env.GATSBY_WORDPRESS_URL_PATH}/graphql`,
  fetchOptions: {
    credentials: 'include',
  },
});

const MembershipFAQs: React.FC<any> = () => {
  return (
    <ApolloProvider client={client as any}>
      <SettingProvider>
        <AdsProvider>
          <Layout key={`${typeof window}`}>
            <SEO
              title="AAA Travel FAQ"
              description="AAA Travel answers your frequently asked questions about booking travel through AAA and the benefits of using AAA Travel services."
              canonicalUrl="/travel/faq"
            />

            <HeroContainer align="middle" justify="center">
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <Title style={{ margin: 'auto' }}>AAA Travel FAQ</Title>
              </Col>
            </HeroContainer>

            <Row style={{ paddingTop: 48 }}>
              <Col xs={{ span: 22, offset: 1 }} md={{ span: 20, offset: 2 }}>
                <p>
                  Have a question about AAA Travel? Find your answers below.
                </p>
                <Collapse defaultActiveKey={['1']} ghost>
                  <Panel
                    header="Why should I use AAA Travel for vacation planning?"
                    key="1"
                  >
                    <p>
                      We save you time and match you with the best vacation for
                      your tastes, dreams and lifestyle. Our knowledgeable
                      travel agents take the time to get to know your vacation
                      goals and match you with the best option for your taste
                      and lifestyle Technology is great and doing research can
                      be fun, but when it comes to making the right vacation
                      choice it can be overwhelming. Our expert agents assist in
                      setting up everything for you, plus AAA has been around
                      for more than 100 years so you know we will be there with
                      you every step of the way on your travels. With AAA you
                      get the buying power of the largest leisure travel agency
                      in North America and the advice of experts at no cost. AAA
                      Members also receive exclusive offers and amenities not
                      available when booking anywhere else.
                    </p>
                  </Panel>
                  <Panel header="WHEN SHOULD I BUY AN AIRLINE TICKET?" key="2">
                    <p>
                      The general rule is to book your ticket when you need it.
                      Most people buy between one and four months prior to
                      travel. Fares tend to rise the closer to the departure
                      date you get based on seat availability. AAA Travel agents
                      use a Global Distribution System which allows them to
                      input travel dates and see all airlines, routings and
                      fares up to 331 days in advance of travel date. Being
                      flexible on your travel dates may also help you save but
                      beware of the “cheap” fares if doing yourself as those may
                      be new “basic economy” fares with hefty restrictions and
                      fees that end up being more than other fares with more
                      perks.
                    </p>
                  </Panel>
                  <Panel
                    header="IS IT SAFE TO TRAVEL TO...  [DESTINATION]?"
                    key="3"
                  >
                    <p>
                      Tour operators, cruise lines and airlines are a good way
                      to gauge if a destination is safe. The last thing they
                      want is to put their clients in danger so will adjust
                      their itineraries. If they are not traveling to a
                      destination then why would you? If they are traveling to a
                      destination but you are still unsure then ask yourself if
                      you will be able to relax and enjoy your vacation if you
                      move ahead. If the answer is no, then we’ll suggest you
                      choose another destination.
                    </p>
                  </Panel>
                  <Panel header="WHAT’S THE BEST WAY TO PICK A CRUISE?" key="5">
                    <p>
                      Choose an itinerary based on where you want to cruise:
                      Alaska and the Caribbean are popular for families. Europe
                      is all about the sights and what you can see off the ship
                      more than the vessel itself. Consider your budget: There
                      are moderately priced cruise lines, luxury lines and
                      others in between. AAA Travel works with the best cruise
                      lines in a variety of price ranges and offers AAA Members
                      specials, amenities and savings on select sailings.
                    </p>
                  </Panel>
                  <Panel header="IS IT MORE EXPENSIVE TO TRAVEL SOLO?" key="6">
                    <p>
                      The short answer is, it can be depending on when, where
                      and how you travel. With cruises and tour operators, the
                      pricing advertised is almost always per person based on
                      double occupancy and unless you can get the single
                      supplement waived you can end up paying the cost of two
                      people. After all, with one person there will likely be
                      less spent than that of two during travel. AAA Travel
                      agents keep track of suppliers that offer the best pricing
                      for solo travelers and when the pricing applies.
                    </p>
                  </Panel>
                  <Panel header="WHAT CAN I TAKE ON AN AIRPLANE?" key="7">
                    <p>
                      The maximum dimensions for a carry-on bag are 9” x 14” x
                      22” including handles and wheels though the smart thing to
                      do is to ask your AAA agent to double check as this may
                      vary based on the airline and aircraft. Since 9/11 the
                      Transportation Security Administration has mandated that
                      wet substances must be limited. You are allowed to take a
                      quart-sized bag of liquids, aerosols, gels, creams and
                      past as long as they are in travel containers 3.4 ounces
                      or smaller. You should also be sure to carry on your
                      necessary medications. If liquid vitamins or other over
                      the counter liquids then you will need to follow the 3-1-1
                      rule or pack them in your checked bag.
                    </p>
                    <p>
                      You can always find the most up-to-date information on
                      what you can bring at{' '}
                      <a href="https://www.tsa.gov/travel/security-screening/whatcanibring/all">
                        TSA.gov`
                      </a>
                      .
                    </p>
                  </Panel>
                  <Panel header="TSA PRE-CHECK OR GLOBAL ENTRY?" key="8">
                    <p>
                      It depends on whether you travel internationally or
                      domestically. While both trusted traveler programs offer
                      expedited security screenings at domestic airports, only
                      Global Entry gets you quicker entry back in to the United
                      States when traveling from international airports. Global
                      Entry is the better deal if you travel the world as both
                      programs are valid for five years but Global Entry
                      includes TSA Pre-check for $100 (TSA Pre-check is $85 for
                      5 years)
                    </p>
                  </Panel>
                  <Panel
                    header="CAN I STILL GET PRINTED TRIPTIKS FROM AAA?"
                    key="9"
                  >
                    <p>
                      Yes! We offer both traditional printed TripTiks and online
                      TripTiks. For printed TripTiks, you can visit{' '}
                      <a href="http://locator.carolinas.aaa.com/?type=travel">
                        any AAA Travel location
                      </a>{' '}
                      or order them online. Order your custom printed TripTiks
                      and get them delivered to your door. Please allow 5-10
                      days for delivery. At this time only Primary Members can
                      order TourBooks, Maps & Publications online. Spouses and
                      dependents can call Member Services at{' '}
                      <a href="tel:1-866-593-862">1-866-593-8626</a>.
                    </p>
                    <p>
                      Online TripTiks allow you to plan your route with exit
                      markers, rest areas, dining and lodging options, and the
                      AAA Member discounts along the way.
                    </p>
                    <p>
                      <a href="https://carolinas.aaa.com/travel/triptiks/">
                        Visit our TripTiks page here.
                      </a>
                    </p>
                  </Panel>
                  <Panel
                    header="WHAT ARE THE TOP DESTINATIONS FOR 2019?"
                    key="10"
                  >
                    <p>
                      AAA Travel’s overall top destinations requested for 2019
                      span the world with adventures for every type of traveler.
                      From cultural destinations to white sandy beaches to
                      incredible natural wonders, they include Indonesia,
                      Belize, Egypt, Slovenia, Portugal, Panama, Ecuador,
                      Greenland, Morocco and Napa Valley.
                    </p>
                  </Panel>
                </Collapse>
              </Col>
            </Row>
          </Layout>
        </AdsProvider>
      </SettingProvider>
    </ApolloProvider>
  );
};

export default MembershipFAQs;
